import { Select, TextField } from '@warp-ds/react';
import { useId } from 'react';
import { sortedUniqueCountryCodes } from 'shared/util/countryCodes';

type PhoneNumberFieldsetProps = {
    landcode: string;
    setLandCode: (value: string) => void;
    phone: string;
    setPhone: (value: string) => void;
    getFieldError: (field: 'phone') => string | null;
    isFieldInvalid: (field: 'phone') => boolean;
};

export const PhoneNumberFieldset = ({
    landcode,
    setLandCode,
    phone,
    setPhone,
    getFieldError,
    isFieldInvalid,
}: PhoneNumberFieldsetProps) => {
    const countryCodeId = useId();
    const phoneNumberId = useId();

    return (
        <fieldset>
            <legend className="text-14 font-bold mb-4 antialiased">Telefonnummer</legend>
            <div className="flex gap-8">
                <label htmlFor={countryCodeId} className="sr-only">
                    Landkode
                </label>
                <Select
                    id={countryCodeId}
                    name="phoneCountryCode"
                    value={landcode}
                    onChange={(e) => setLandCode(e.target.value)}
                    required
                    data-testid="rentalRequestPhoneCountryCode">
                    <option value="+47">+47</option>
                    {sortedUniqueCountryCodes.map((cc) => (
                        <option value={`+${cc}`} key={cc} data-testid={`cc-${cc}`}>
                            +{cc}
                        </option>
                    ))}
                </Select>
                <label htmlFor={phoneNumberId} className="sr-only">
                    Telefonnummer
                </label>
                <TextField
                    id={phoneNumberId}
                    name="phoneNumber"
                    type="tel"
                    inputMode="numeric"
                    className="w-full"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    pattern="\d*"
                    helpText={getFieldError('phone')}
                    invalid={isFieldInvalid('phone')}
                    data-testid="rentalRequestPhoneNumber"
                />
            </div>
        </fieldset>
    );
};
